module.exports = __webpack_public_path__ + "4e806def1bcd075b3d490c9e5accc7ac.png";